import { act } from "react";
import { CREATE_AUTOMATION, GET_ACTIONS_DATA, GET_AUTOMATION_APP_DATA, GET_AUTOMATION_DATA, GET_TRIGGERS_DATA } from "../Types/types";

const initialState = {
  automationApp: null,
  automationDetails: null,
  triggerDetails: null,
  actionDetails: null,
  createAutomation: null,
};

const automationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_AUTOMATION_APP_DATA:
      return { ...state, automationApp: action.payload };
    case GET_AUTOMATION_DATA:
      return { ...state, automationDetails: action.payload };
    case GET_TRIGGERS_DATA:
      return { ...state, triggerDetails: action.payload };
    case GET_ACTIONS_DATA:
      return { ...state, actionDetails: action.payload };
    case CREATE_AUTOMATION:
      return {...state,createAutomation: action.payload }
    default:
      return state;
  }
};

export default automationReducer;
